import React, { useEffect, useRef, useState } from "react";

import { Link } from "react-router-dom";
import { Popup, Spinner } from "../components";
import { ArrowLeft } from "react-feather";
import { useForm } from "react-hook-form";
import { useHttp } from "../hooks/useHttp";
import { useMutation, useQuery } from "@tanstack/react-query";
import { CTable, CTableHead, CTableRow, CTableHeaderCell, CTableBody, CTableDataCell } from "@coreui/react";

import axiosInstance from "../apis/gvmdesk";
import openToast from "../utils/sweetAlert";
import PhoneNumber from "../components/PhoneNumber";
import LoadingCenter from "../components/LoadingCenter";
import useAxiosFunction from "../hooks/useAxiosFunction";
import ProspectRow from "../components/Prospect/ProspectRow";
import PopupSelectPhone from "../components/PopupSelectPhone";
import { formatAdminTransferLabel } from "../utils/porte";


import {
  yupResolver
} from "@hookform/resolvers/yup";

import * as yup from "yup";
import ProspectPagination from "../components/Prospect/ProspectPagination";

const prospectSchema = yup.object({
  prospect: yup.string().required("É necessário selecionar uma opção acima!").nullable()
}).required();

const Prospect = () => {
  const { register: registerPhone, handleSubmit: handleSubmitPhone, reset: resetPhone } = useForm();

  // States
  const page = useRef(1);
  const [callId, setCallId] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [feedbackBttn, setFeedbackBttn] = useState(false);

  // Triggers
  const [callTrigger, setCallTrigger] = useState(false);
  const [phoneTrigger, setPhoneTrigger] = useState(false);

  const request = useHttp();
  // Paginação: 20 itens por página (padrão management-customers)
  const { data: customers, isLoading, refetch, isFetching } = useQuery(
    ["prospect-customers"],
    () => request({ url: `/admin_prospect/list?page=${page.current}&per_page=20`, method: "GET" }),
    { refetchOnWindowFocus: false }
  );

  // Pega o cliente
  const customerHandleMutation = useMutation({
    mutationKey: ["customerHandle"],
    mutationFn: id => request({ url: "/users/list/phone/" + id, method: "GET" }), // customer.id
    onSuccess: response => console.log(response.data)
  });

  const openCustomerModal = (e, id) => {
    e.preventDefault();
    customerHandleMutation.mutate(id);
    setPhoneTrigger(true);
  }

  // Liga
  const callMutation = useMutation({
    mutationFn: number => request({ url: "/calls/ligar/prospect", method: "POST", data: { user_id: Number(customerId), phone: number, outdated: true } }),
    onSuccess: response => {
      if (response.data.error) {
        openToast("error", "Ocorreu um erro", response.data.message);
      }

      if (!response.data.error) {
        setCallId(response.data.call_id);
        setPhoneTrigger(false);
        setCallTrigger(true);
        resetPhone();
        openToast("success", "Sucesso", response.data.message);
      }
    }
  });

  const handleSetNumber = data => callMutation.mutate(data.number);

  // -> ligar
  // -> transferir por porte

  /**
 *
 *
 *
 *
 *
 * Transferir conversas prospect
 */
  const { register: registerProspect, handleSubmit: handleSubmitProspect, reset: resetProspect, formState: { errors: prospectErrors } } = useForm({
    resolver: yupResolver(prospectSchema)
  });

  const [prospectRes, setProspectRes, prospectLoading, prospectError, prospectFetch] = useAxiosFunction();

  const [chatChosen, setChatChosen] = useState();
  const [popupProspect, setPopupProspect] = useState(false);
  const { data: transferAdminsResponse, isLoading: transferAdminsLoading } = useQuery(
    ["prospect-transfer-admins", popupProspect],
    () => request({ url: "/admins/list?sales_only=1", method: "GET" }),
    { enabled: popupProspect, refetchOnWindowFocus: false }
  );
  const transferAdmins = transferAdminsResponse?.data || [];

  const transferConversationProspect = async (event, chat) => {
    event?.preventDefault();
    setPopupProspect(true);
    setChatChosen(chat);
  }

  const transferProspect = data => {
    if (!chatChosen?.user_id || !chatChosen?.socialMedia_id) {
      openToast("error", "Ocorreu um erro", "Conversa não localizada para transferência.");
      return;
    }

    const selected = String(data.prospect || "");
    const isAdminTransfer = selected.startsWith("admin:");
    const adminId = selected.replace("admin:", "");

    prospectFetch({
      axiosInstance,
      method: "POST",
      url: "/admin_prospect/transfer/chat",
      redirect_to: "",
      data: isAdminTransfer ? {
        "admin_id": adminId,
        "user_id": chatChosen.user_id,
        "socialMedia_id": chatChosen.socialMedia_id
      } : {
        "porte": data.prospect,
        "user_id": chatChosen.user_id,
        "socialMedia_id": chatChosen.socialMedia_id
      }
    });
  }

  useEffect(() => {
    if (prospectRes?.error === false) {
      setPopupProspect(false);
      resetProspect();
      refetch();
    }
  }, [prospectRes, resetProspect, refetch]);

  // phone trigger

  return (
    <div className="d-flex flex-column">
      <div className="header border-bottom border-top-right-radius-8">
        <div className="d-flex flex-row align-center">
          <Link to="/management-customers" className="dropdown__btn rounded__btn mr-10">
            <ArrowLeft />
          </Link>

          <span>
            Prospect
          </span>
        </div>
      </div>

      <div className="dashboard__container">
        <Popup title="Transferir conversa prospect" trigger={popupProspect} setTrigger={setPopupProspect}>
          <div className="u-all-padding">
            <form onSubmit={handleSubmitProspect(transferProspect)}>
              <ul className="last-access-list mb-0">
                {transferAdminsLoading && <LoadingCenter />}

                {!transferAdminsLoading && transferAdmins?.length > 0 && (
                  <>
                    <li className="mb-10">
                      <strong>Transferir para admin</strong>
                    </li>
                    {transferAdmins.map(admin => (
                      <li key={admin.id}>
                        <label className="label-last-accesses">
                          <input type="radio" name="prospect" value={`admin:${admin.id}`} {...registerProspect("prospect")} />
                          <span>{formatAdminTransferLabel(admin)}</span>
                        </label>
                      </li>
                    ))}
                    <li className="mt-20 mb-10">
                      <strong>Transferir automático por porte</strong>
                    </li>
                  </>
                )}

                <li>
                  <label className="label-last-accesses">
                    <input type="radio" name="prospect" value="PP" {...registerProspect("prospect")} />
                    <span>Pequeno porte - automático</span>
                  </label>
                </li>
                <li>
                  <label className="label-last-accesses">
                    <input type="radio" name="prospect" value="MP" {...registerProspect("prospect")} />
                    <span>Médio porte - automático</span>
                  </label>
                </li>
                <li>
                  <label className="label-last-accesses">
                    <input type="radio" name="prospect" value="GP" {...registerProspect("prospect")} />
                    <span>Grande porte - automático</span>
                  </label>
                </li>
              </ul>

              {prospectErrors.prospect && <div className="text-error">{prospectErrors.prospect.message}</div>}
              <div></div>

              <div className="popup-footer">
                <button className="btn btn-primary" type="submit" disabled={prospectLoading}>
                  {prospectLoading ? <Spinner /> : "Concluir"}
                </button>
                <button className="btn btn-light mr-20" type="button" onClick={() => setPopupProspect(false)}>Cancelar</button>
              </div>
            </form>
          </div>
        </Popup>

        <PopupSelectPhone width="700" trigger={phoneTrigger} setTrigger={setPhoneTrigger}>
          {customerHandleMutation.isLoading && <LoadingCenter />}
          <form onSubmit={handleSubmitPhone(handleSetNumber)}>
            <div className="row-grid">
              {!customerHandleMutation.isLoading &&
                customerHandleMutation.data?.data.map((phone, index) => {
                  return (
                    <PhoneNumber key={index} title={phone.name} name="number" value={phone.name} qtd={phone.qtd} lastOne={String(phone.lastOne)} register={registerPhone} />
                  );
                })}
            </div>
            <div className="popup-footer">
              <button className="btn btn-primary" type="submit" disabled={customerHandleMutation.isLoading}>
                {callMutation.isLoading ? <Spinner /> : "Ligar"}
              </button>
            </div>
          </form>
        </PopupSelectPhone>

        {(isLoading || isFetching) && <LoadingCenter />}
        {/* Admins */}
        {!isLoading && !isFetching && <CTable hover>
          <CTableHead>
            <CTableRow>
              <CTableHeaderCell scope="col">
                <span className="text-color">Data</span>
              </CTableHeaderCell>
              <CTableHeaderCell scope="col">
                <span className="text-color">Nome cliente</span>
              </CTableHeaderCell>
              <CTableHeaderCell scope="col">
                <span className="text-color">Observação</span>
              </CTableHeaderCell>
              <CTableHeaderCell scope="col">
                <span className="text-color">Nome prospect</span>
              </CTableHeaderCell>
              <CTableHeaderCell scope="col">
                <span className="text-color">Nome destino</span>
              </CTableHeaderCell>
              <CTableHeaderCell scope="col">
                <span className="text-color">Pós ligação</span>
              </CTableHeaderCell>
              <CTableHeaderCell scope="col" width={44}>
              </CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          <CTableBody>
            {(customers?.data?.prospect_list?.length ?? 0) === 0 ? (
              <CTableRow>
                <CTableDataCell colSpan={7} className="text-center">
                  Nenhum registro encontrado
                </CTableDataCell>
              </CTableRow>
            ) : (
              customers?.data?.prospect_list.map(customer => (
                <ProspectRow
                  key={`${customer?.id ?? Math.random()}`}
                  transferConversationProspect={transferConversationProspect}
                  customer={customer}
                  mutation={customerHandleMutation}
                  openCustomerModal={openCustomerModal}
                  setCustomerId={setCustomerId}
                />
              ))
            )}
          </CTableBody>
        </CTable>}

        <ProspectPagination customers={customers} page={page} refetch={refetch} />
      </div>
    </div >
  );
}

export default Prospect;
